/**
 * "Rep follow-through" drill-downs from the Exec Sales Dashboard (?gap=<key>).
 * The rules live in backend/src/services/repGaps.js; these are the list-page labels.
 */
export type RepGapEntity = 'lead' | 'opportunity' | 'account' | 'task'

export const REP_GAPS: Record<string, { entity: RepGapEntity; label: string }> = {
  untouched_leads: { entity: 'lead', label: 'Leads nobody has contacted' },
  past_close: { entity: 'opportunity', label: 'Close date has passed' },
  quote_unchased: { entity: 'opportunity', label: 'Quote presented, not chased' },
  quote_expiring: { entity: 'opportunity', label: 'Quote expiring in the next 14 days' },
  renewal_unworked: { entity: 'account', label: 'Renewal due, nobody working it' },
  overdue_tasks: { entity: 'task', label: 'Overdue by more than 7 days' },
  single_threaded: { entity: 'opportunity', label: 'Only one contact at the customer' },
  stuck: { entity: 'opportunity', label: 'Active but stuck in the same stage' },
}

/** The ?gap value if it is a known gap for this list, else undefined. */
export function repGapFor(entity: RepGapEntity, value: string | null): string | undefined {
  if (!value) return undefined
  const g = REP_GAPS[value]
  return g && g.entity === entity ? value : undefined
}
